import { Box } from '@mui/material';
import { Ref } from 'react';
import ReCaptcha from 'react-google-recaptcha';

type Props = {
  reRef: Ref<ReCaptcha>;
  siteKey: string;
};

export const Captcha: React.FC<Props> = ({ reRef, siteKey }) => {
  return (
    <Box sx={{ mb: '0.5rem', position: 'absolute' }}>
      <ReCaptcha badge="bottomright" size="invisible" sitekey={siteKey} ref={reRef} />
    </Box>
  );
};
